import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Session } from '../../../../globals/store/programs.data';
import { InputDialogBodyComponent } from './input.dialog.body.component';
import { DialogPositionNumbers } from '../../../../globals/store/dialog.selector.data';


@Component({
    selector: 'input-dialog',
    imports: [InputDialogBodyComponent],
    template: `
<input-dialog-body
  [data]="data"
  [dialogRef]="dialogRef"
></input-dialog-body>
  `,
    standalone: true,
})
export class InputDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputDialogData,
  ) {
    this.data.value = data.currentValue || ''
  }

}

export interface InputDialogSelection { id: string, greyText?: string, name: string }
export interface InputDialogData {
  title: string
  successLabel: string
  alternativeLabel?: string
  value?: string
  secondValue?: string
  hideCancel?: boolean
  delete?: boolean
  deleteText?: string
  deleteTitle?: string
  deleteButtonText?: string
  currentValue?: string
  header?: string
  placeholder: string
  secondPlaceholder?: string
  backgroundColor: string
  emptyOK?: boolean
  alternativeEmptyOK?: boolean
  multiLine?: boolean
  small?: boolean
  position?: DialogPositionNumbers
  time?: string
  requireSelection?: boolean
  selections?: InputDialogSelection[]
  maxHeight?: string
  midRightLabel?: string
}



export type InputDialogReturnType = 'MainButton' | 'AlternativeButton' | 'Delete'
export interface InputDialogReturnData {
  type: InputDialogReturnType,
  values?: string[],
  time?: string
  selection?: string
  importedSessions?: Partial<Session>[]
}